export const CPC_OFFERS_DIALOG_CONTENT: Record<string, Record<string, string>> = {
  // CIT
  'adfeb934-c4de-11ed-a40f-1f42eaa7bc05': {
    apyDescriptor: 'competitive APY',
    definitiveArticle: '',
    monthlyFeeDescriptor: 'no monthly fees',
    content: 'with',
    extraContent: '',
  },
  // TODO: re-add it when needed by product.
  // Amex
  // 'e7dabbce-259e-11e8-9c02-6ff6cb82cb54': {
  //   apyDescriptor: 'competitive APY',
  //   content: 'with',
  //   definitiveArticle: 'The',
  //   monthlyFeeDescriptor: 'no monthly fees',
  //   extraContent: 'from a well-known financial institution',
  // },
  // Lending Club
  // '51d4b694-6588-11ef-929f-47aae61e541c': {
  //   apyDescriptor: 'higher APY',
  //   content: 'when balance requirements are met and',
  //   definitiveArticle: '',
  //   monthlyFeeDescriptor: 'no monthly fees',
  //   extraContent: '',
  // },
};

export const CPC_OFFERS_CONFIG = Object.keys(CPC_OFFERS_DIALOG_CONTENT);

export const WEALTHFRONT_OFFER_ID = 'bec439aa-bade-11e9-a54a-0f3f0720e464';

export function isWealthFrontModalOffer(
  isWealthFrontExperimentActive: boolean | undefined,
  marketplaceEntityId: string,
) {
  return !!isWealthFrontExperimentActive && marketplaceEntityId === WEALTHFRONT_OFFER_ID;
}
